import React from "react";

function RightPanel() {

    return (
        <div id="right">
            <div id="info">
                <h2>Info</h2>
                <div name="variables_description"></div>
            </div>
        </div>
    )
}

export default RightPanel;